import { observer } from 'mobx-react'
import React from 'react'

import { BadgeColors } from '@avantstay/backoffice-core'

import { ExtendedColumnKey } from '@new/__global/components/FiltersFramework'
import {
  ExtendedColumnCell,
  ExtendedHeaderCell,
} from '@new/domains/fastBookingsTapeChart/__commonStyles'
import { HomeExtendedInfo } from '@new/domains/fastBookingsTapeChart/stores/FastBookingsTapeChartStore'

import * as S from './Attention.styles'

const columnWidth = 150

export const AttentionHeader = () => {
  return (
    <ExtendedHeaderCell key={`col-header-${ExtendedColumnKey.attentionBadges}`} width={columnWidth}>
      Attention
    </ExtendedHeaderCell>
  )
}

const AttentionCell = observer(({ home }: { home?: HomeExtendedInfo }) => {
  const badges = home?.operationTags?.short
    ?.sort((a, b) => a.length - b.length)
    ?.map(tag => ({
      badgeColor: BadgeColors.neutralMedium,
      children: tag,
    }))
    .filter(Boolean)

  return (
    <ExtendedColumnCell width={columnWidth}>
      {badges?.length ? <S.BadgesStyles badges={badges} /> : null}
    </ExtendedColumnCell>
  )
})

export const Attention = {
  header: <AttentionHeader />,
  columnKey: ExtendedColumnKey.attentionBadges,
  width: columnWidth,
  renderer: (home: HomeExtendedInfo | undefined) => (
    <AttentionCell key={`col-${ExtendedColumnKey.attentionBadges}-${home?.id}`} home={home} />
  ),
}
